module.exports = __webpack_public_path__ + "img/139.2796e602.jpg";